import { StickyFeatureSection } from "../StickyScroll";

export default function DemoOne() {
  return (
    <div className="w-full">
      <StickyFeatureSection />
    </div>
  );
}
